
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Toast } from 'vant';
import PopupShell from './PopupShell.vue';
import ConfirmButton from './ConfirmButton.vue';

/** 抽奖结果弹窗（中奖 / 未中奖），实物奖品支持直接填写收货地址 */
@Component({
  components: { PopupShell, ConfirmButton },
})
export default class LotteryResultPopup extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;
  @Prop({ type: Boolean, default: true }) readonly win!: boolean;
  @Prop({ type: String, default: '' }) readonly image!: string;
  @Prop({ type: String, default: '' }) readonly text!: string;
  @Prop({ type: Boolean, default: false }) readonly needAddress!: boolean;

  address = '';
  name = '';

  @Watch('value')
  onVisible(visible: boolean) {
    if (visible) {
      this.address = '';
      this.name = '';
    }
  }

  onConfirm() {
    if (this.needAddress) {
      if (!this.name) {
        Toast('请填写收货人姓名');
        return;
      }
      if (!this.address) {
        Toast('请填写您的收货地址');
        return;
      }
    }
    this.$emit('confirm', {
      name: this.name,
      address: this.address,
    });
  }
}
